module.exports = __webpack_public_path__ + "img/a1137b1.jpg";